<script lang="ts">
    import dayjs from 'dayjs';

    import { filtersContext, sortValue } from '$saga/views/Search/store';
</script>

{#each $filtersContext.formValues.destination as value (value)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="destination[]"
        {value}
    />
{/each}

{#each $filtersContext.formValues.theme as value (value)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="theme[]"
        {value}
    />
{/each}

<input
    aria-hidden="true"
    tabindex="-1"
    class="hidden"
    name="startDate"
    value={$filtersContext.formValues.startDate
        ? dayjs($filtersContext.formValues.startDate.toString()).format(
              'DD/MM/YYYY',
          )
        : ''}
/>
<input
    aria-hidden="true"
    tabindex="-1"
    class="hidden"
    name="endDate"
    value={$filtersContext.formValues.endDate
        ? dayjs($filtersContext.formValues.endDate.toString()).format(
              'DD/MM/YYYY',
          )
        : ''}
/>

{#each $filtersContext.formValues.months as month (month)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="month[]"
        value={month}
    />
{/each}

<input
    aria-hidden="true"
    tabindex="-1"
    class="hidden"
    name="flexibility"
    value={$filtersContext.formValues.flexibility}
/>

<input
    aria-hidden="true"
    tabindex="-1"
    class="hidden"
    name="nbPax"
    value={Number($filtersContext.formValues.nbPax)}
/>

<input
    aria-hidden="true"
    tabindex="-1"
    class="hidden"
    name="sort"
    value={$sortValue}
/>

<!-- Secondary filters inputs -->
{#each $filtersContext.formValues.levels as level (level)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="level[]"
        value={level}
    />
{/each}

{#each $filtersContext.formValues.types as type (type)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="type[]"
        value={type}
    />
{/each}

{#if null !== $filtersContext.formValues.durationMin}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="durationMin"
        value={$filtersContext.formValues.durationMin}
    />
{/if}

{#if null !== $filtersContext.formValues.durationMax}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="durationMax"
        value={$filtersContext.formValues.durationMax}
    />
{/if}

{#if null !== $filtersContext.formValues.budgetMin}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="budgetMin"
        value={$filtersContext.formValues.budgetMin}
    />
{/if}

{#if null !== $filtersContext.formValues.budgetMax}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="budgetMax"
        value={$filtersContext.formValues.budgetMax}
    />
{/if}

{#each $filtersContext.formValues.tags as tag (tag)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="tag[]"
        value={tag}
    />
{/each}

{#each $filtersContext.formValues.resorts as resort (resort)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="resort[]"
        value={resort}
    />
{/each}

{#if $filtersContext.formValues.bestReviewed}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        id="bestReviewed"
        name="bestReviewed"
        value="1"
    />
{/if}

{#if $filtersContext.formValues.exclusiveSport}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        id="exclusiveSport"
        name="exclusiveSport"
        value="1"
    />
{/if}

{#if $filtersContext.formValues.keywords}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        id="keywords"
        name="keywords"
        value={$filtersContext.formValues.keywords}
    />
{/if}
